import React from "react";
import { Container, Row, Col } from "reactstrap";
import HqBuilding from "../../../Images/home/hqBuilding.jpg";
import DeltaBuilding from "../../../Images/home/deltaBuilding.JPG";

// import Imran from "../../../Images/home/imran.cr2";
import Ahtasham from "../../../Images/home/ahtasham.jpg";
import Ahsan from "../../../Images/home/deltaBuilding.JPG";
import Jawwad from "../../../Images/home/deltaBuilding.JPG";
import Taimur from "../../../Images/home/deltaBuilding.JPG";
import "./style.css";

function AboutUs() {
  return (
    <div className="sectionAboutus">
      <Container>
        <Row>
          <Col className="ml-auto mr-auto" md="12">
            <h1 className="title tc">
              <b>The Vision</b>{" "}
            </h1>

            <div className="typography-line tc">
              <blockquote className="blockquote">
                <div className="blockquote-footer">
                  <cite title="source Title" className="aboutUsTagLine">
                    <strong> TO MAKE A DIFFERENCE & IMPACT LIVES</strong>
                  </cite>
                </div>
              </blockquote>
            </div>

            <h4 className="aboutUsText tc">
              <small>
                Based out of Palm Beach, Florida with back offices overseas. Pay
                per call, Digital Marketing and Call Centers. A leadership team
                with 17 years under their belt in Contact Centers. Currently
                operating over 500 Seats in across multiple locations,
                generating 40,000 Transfers/Month We pride ourselves on the
                quality of our business, how we treat our people who eventually
                take care of our customers. Servicing Inbound customer service,
                sales, outbound transfers across all Insurance verticals, both
                performance based and flat hourly servicing models
              </small>
            </h4>
          </Col>
        </Row>
        <br />
      </Container>
      <br />

      <ul class="cards">
        <li>
          <a href="" class="card">
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcToIXp9I0Blvtqu1cRyDcfzLsVnHZmsqCh2CQ&usqp=CAU"
              class="card__image"
              alt=""
            />
            <div class="card__overlay">
              <div class="card__header">
                <svg class="card__arc" xmlns="http://www.w3.org/2000/svg">
                  <path />
                </svg>
                <img
                  class="card__thumb"
                  src="https://st.depositphotos.com/2101611/3925/v/600/depositphotos_39258143-stock-illustration-businessman-avatar-profile-picture.jpg"
                  alt=""
                />
                <div class="card__header-text">
                  <h3 class="card__title">WORK HEAD QUATERS - PK</h3>
                  <span class="card__status">Genral Manager Jawwad Naseer</span>
                </div>
              </div>
              <p class="card__description">
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Asperiores, blanditiis?
              </p>
            </div>
          </a>
        </li>
        <li>
          <a href="" class="card">
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcToIXp9I0Blvtqu1cRyDcfzLsVnHZmsqCh2CQ&usqp=CAU"
              class="card__image"
              alt=""
            />
            <div class="card__overlay">
              <div class="card__header">
                <svg class="card__arc" xmlns="http://www.w3.org/2000/svg">
                  <path />
                </svg>
                <img
                  class="card__thumb"
                  src={
                    "https://st.depositphotos.com/2101611/3925/v/600/depositphotos_39258143-stock-illustration-businessman-avatar-profile-picture.jpg"
                  }
                  alt=""
                />
                <div class="card__header-text">
                  <h3 class="card__title">WORK DELTA - PK</h3>
                  <span class="card__status">
                    Director Operations Ahtasham Khan
                  </span>
                </div>
              </div>
              <p class="card__description">
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Asperiores, blanditiis?
              </p>
            </div>
          </a>
        </li>
        <li>
          <a href="" class="card">
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcToIXp9I0Blvtqu1cRyDcfzLsVnHZmsqCh2CQ&usqp=CAU"
              class="card__image"
              alt=""
            />
            <div class="card__overlay">
              <div class="card__header">
                <svg class="card__arc" xmlns="http://www.w3.org/2000/svg">
                  <path />
                </svg>
                <img
                  class="card__thumb"
                  src="https://st.depositphotos.com/2101611/3925/v/600/depositphotos_39258143-stock-illustration-businessman-avatar-profile-picture.jpg"
                  alt=""
                />
                <div class="card__header-text">
                  <h3 class="card__title">WORK TANGO - PK</h3>
                  <span class="card__status">
                    Director Operations Ahsan Abbasi
                  </span>
                </div>
              </div>
              <p class="card__description">
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Asperiores, blanditiis?
              </p>
            </div>
          </a>
        </li>
        <li>
          <a href="" class="card">
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcToIXp9I0Blvtqu1cRyDcfzLsVnHZmsqCh2CQ&usqp=CAU"
              class="card__image"
              alt=""
            />
            <div class="card__overlay">
              <div class="card__header">
                <svg class="card__arc" xmlns="http://www.w3.org/2000/svg">
                  <path />
                </svg>
                <img
                  class="card__thumb"
                  src="https://st.depositphotos.com/2101611/3925/v/600/depositphotos_39258143-stock-illustration-businessman-avatar-profile-picture.jpg"
                  alt=""
                />
                <div class="card__header-text">
                  <h3 class="card__title">FLORIDA OFFICE - USA</h3>
                  <span class="card__status">
                    Director Operations Imran Bangash
                  </span>
                </div>
              </div>
              <p class="card__description">
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Asperiores, blanditiis?
              </p>
            </div>
          </a>
        </li>

        <li>
          <a href="" class="card">
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcToIXp9I0Blvtqu1cRyDcfzLsVnHZmsqCh2CQ&usqp=CAU"
              class="card__image"
              alt=""
            />
            <div class="card__overlay">
              <div class="card__header">
                <svg class="card__arc" xmlns="http://www.w3.org/2000/svg">
                  <path />
                </svg>
                <img
                  class="card__thumb"
                  src="https://st.depositphotos.com/2101611/3925/v/600/depositphotos_39258143-stock-illustration-businessman-avatar-profile-picture.jpg"
                  alt=""
                />
                <div class="card__header-text">
                  <h3 class="card__title">WORK FROM HOME - PK</h3>
                  <span class="card__status">General Manager Taimur Mirza</span>
                </div>
              </div>
              <p class="card__description">
                Lorem ipsum dolor sit amet consectetur adipisicing elit.
                Asperiores, blanditiis?
              </p>
            </div>
          </a>
        </li>
      </ul>

      <br />
    </div>
  );
}

export default AboutUs;
